import React, { ReactElement, ForwardedRef } from 'react';
import ContentListContainer from '../../../../components/content-list-container/content-list-container.component';
import useScreenMobile from '../../../../hooks/use-screen-mobile';

const ContentListContainerOffset: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const BLOCK_OFFSET_HEADER: number = 64;
  const BLOCK_OFFSET_PAGE_PADDINGS: number = 40;
  const BLOCK_OFFSET_PAGE_PADDINGS_MOBILE: number = 10;
  const BLOCK_OFFSET_CONTENT_HEADER: number = 60;
  const BLOCK_OFFSET_CONTROLS: number = 45;
  const BLOCK_OFFSET_NO_CONTROLS: number = 12;
  const BLOCK_OFFSET_STATUS_FILTER: number = 80;
  const BLOCK_OFFSET_BUTTONS: number = 50;
  const BLOCK_OFFSET_PAGINATION: number = 67;
  const BLOCK_OFFSET_STATISTICS_BAR: number = 70;
  const BLOCK_OFFSET_MAP: number = 42;
  const BLOCK_OFFSET_DROP_BOX: number = 70;
  const BLOCK_OFFSET_FILTERS: number = 42;
  const BLOCK_OFFSET_TABS: number = 50;

  const {
    isDefault,
    withFilters,
    withButtons,
    withPagination,
    withNoControls,
    withStatisticsBar,
    withStatusFilter,
    withTabs,
    withSubTabs,
    withMap,
    withDropBox,
    className,
    onScroll,
    children,
  } = props;

  const isMobileScreen: boolean = useScreenMobile();

  const tableOffsetControls: number = !withNoControls ? BLOCK_OFFSET_CONTROLS : BLOCK_OFFSET_NO_CONTROLS;
  const tableOffsetFilters: number = withFilters ? BLOCK_OFFSET_FILTERS : 0;
  const tableOffsetButtons: number = withButtons ? BLOCK_OFFSET_BUTTONS : 0;
  const tableOffsetPagination: number = withPagination ? BLOCK_OFFSET_PAGINATION : 0;
  const tableOffsetStatisticsBar: number = withStatisticsBar ? BLOCK_OFFSET_STATISTICS_BAR : 0;
  const tableOffsetStatusFilter: number = withStatusFilter ? BLOCK_OFFSET_STATUS_FILTER : 0;
  const tableOffsetTabs: number = withTabs ? BLOCK_OFFSET_TABS : 0;
  const tableOffsetSubTabs: number = withSubTabs ? BLOCK_OFFSET_TABS : 0;
  const tableOffsetMap: number = withMap ? BLOCK_OFFSET_MAP : 0;
  const tableOffsetDropBox: number = withDropBox ? BLOCK_OFFSET_DROP_BOX : 0;
  const tableOffsetPagePaddings: number = isMobileScreen ? BLOCK_OFFSET_PAGE_PADDINGS_MOBILE
    : BLOCK_OFFSET_PAGE_PADDINGS;
  const tableOffsetTop: number = BLOCK_OFFSET_HEADER + tableOffsetPagePaddings + BLOCK_OFFSET_CONTENT_HEADER
    + tableOffsetControls + tableOffsetFilters + tableOffsetTabs + tableOffsetSubTabs + tableOffsetMap
    + tableOffsetDropBox + tableOffsetStatusFilter + tableOffsetStatisticsBar + tableOffsetButtons
    + tableOffsetPagination;
  const maxHeight: string | undefined = !isDefault && tableOffsetTop ? `calc(100vh - ${tableOffsetTop}px)` : undefined;

  return (
    <ContentListContainer
      isDefault={isDefault}
      ref={ref}
      maxHeight={maxHeight}
      className={className}
      onScroll={onScroll}
    >
      {children}
    </ContentListContainer>
  );
}));

export default ContentListContainerOffset;
